import { Logo } from "./Logo";

export const AuthShell = ({ title, subtitle, children, footer }) => (
  <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-[#080808] px-5 py-16">
    <div className="pointer-events-none absolute left-1/2 top-0 h-[420px] w-[720px] -translate-x-1/2 rounded-full bg-[#ff3b91]/12 blur-[130px]" />
    <div className="pointer-events-none absolute bottom-0 right-0 h-80 w-80 rounded-full bg-[#800d43]/25 blur-[120px]" />
    <div className="relative w-full max-w-sm animate-fade-up">
      <Logo className="mb-10" />
      <h1 className="font-display text-3xl font-bold tracking-tight text-white">{title}</h1>
      {subtitle && <p className="mt-2 text-sm text-zinc-400">{subtitle}</p>}
      <div className="mt-8">{children}</div>
      {footer && <div className="mt-8 text-sm text-zinc-500">{footer}</div>}
    </div>
  </div>
);

export const Field = ({ label, ...props }) => (
  <label className="block">
    <span className="eyebrow mb-2 block">{label}</span>
    <input className="field" {...props} />
  </label>
);

export const FormError = ({ msg }) => msg ? <div data-testid="form-error" className="rounded-xl border border-red-500/30 bg-red-500/10 px-4 py-2.5 text-sm text-red-300">{msg}</div> : null;
